import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { RiDeleteBin2Line } from 'react-icons/ri';

interface DeleteModalProps {
  show?: boolean;
  onDeleteClick?: () => void;
  onCloseClick?: () => void;
  recordId?: string;
  title?: string;
  message?: string;
  cancelBtnMsg?: string;
  confirmBtnMsg?: string;
  annotation?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show,
  onDeleteClick,
  onCloseClick,
  recordId,
  title = 'Are you sure ?',
  message = ' Are you sure you want to remove this record',
  cancelBtnMsg = 'Close',
  confirmBtnMsg = 'Yes, Delete It!',
  annotation = '',
}) => {
  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      id="delete-modal"
    >
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          {/* <i className="ri-delete-bin-line display-5 text-danger"></i> */}
          <RiDeleteBin2Line className="text-danger display-5" />
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{title}</h4>
            <p className="text-muted mx-4 mb-0">
              {message}
              {recordId ? (
                <span
                  style={{
                    fontWeight: 'bold',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                  }}
                >{` "${recordId}" `}</span>
              ) : (
                ''
              )}
              ?
            </p>
            {annotation && annotation !== '' && (
              <>
                <p className="text-muted mt-2 mb-0">
                  <small>{annotation}</small>
                </p>
              </>
            )}
          </div>
        </div>
        {/* <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light material-shadow-none"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
            data-testid="close-modal-button"
          >
            {cancelBtnMsg}
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger material-shadow-none"
            id="delete-record"
            onClick={onDeleteClick}
            data-testid="confirm-delete-button"
          >
            {confirmBtnMsg}
          </button>
        </div> */}
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light material-shadow-none"
            onClick={onCloseClick}
            data-testid="cancel-button"
          >
            {cancelBtnMsg}
          </button>
          <button
            type="button"
            className="btn w-sm btn-primary material-shadow-none"
            onClick={onDeleteClick}
            data-testid="confirm-button"
          >
            {confirmBtnMsg}
          </button>
        </div>
      </ModalBody>
    </Modal>
  ) as unknown as JSX.Element;
};

export default DeleteModal;
